'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentBackScreenAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-instructions-back-device-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentBackScreenAnimation"
    />
  );
}
